export default __webpack_public_path__ + "images/AF.0a07bcd.png";